module.exports = __webpack_public_path__ + "img/contract-icon.c4f4bfb0.svg";